module.exports = __webpack_public_path__ + "img/haijunlan.89d3ff35.png";